(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-countdown')) {
    /*
     * Countdown in the announcement bar. Modes (data-mode):
     * - midnight_local: counts down to 00:00 in the visitor's own time zone, then restarts
     * - midnight_new_york: counts down to 00:00 New York time (EST/EDT), then restarts
     * - duration: counts down a fixed duration and restarts; cycles are aligned to the
     *   Unix epoch, so a page reload doesn't reset it
     */
    class CustomCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'midnight_local';
        this.duration = Number(this.dataset.durationSeconds) * 1000;
        if (this.mode === 'duration' && !this.duration) return;

        this.units = {
          hours: this.querySelector('[data-unit="hours"]'),
          minutes: this.querySelector('[data-unit="minutes"]'),
          seconds: this.querySelector('[data-unit="seconds"]'),
        };

        this.update();
        this.interval = setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      secondsUntilMidnight(timeZone) {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone,
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hourCycle: 'h23',
        }).formatToParts(new Date());
        const value = (type) => Number(parts.find((part) => part.type === type)?.value || 0);
        const elapsed = value('hour') * 3600 + value('minute') * 60 + value('second');
        return 86400 - elapsed;
      }

      remainingSeconds() {
        if (this.mode === 'midnight_new_york') return this.secondsUntilMidnight('America/New_York');
        if (this.mode === 'midnight_local') return this.secondsUntilMidnight(undefined);
        return Math.ceil((this.duration - (Date.now() % this.duration)) / 1000);
      }

      update() {
        const remaining = this.remainingSeconds();
        const hours = Math.floor(remaining / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;

        this.units.hours.textContent = String(hours).padStart(2, '0');
        this.units.minutes.textContent = String(minutes).padStart(2, '0');
        this.units.seconds.textContent = String(seconds).padStart(2, '0');
      }
    }

    customElements.define('custom-countdown', CustomCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-back-to-top')) {
    class CustomBackToTop extends HTMLElement {
      connectedCallback() {
        this.querySelector('button').addEventListener('click', () => {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
          document.getElementById('MainContent')?.focus({ preventScroll: true });
        });

        this.onScroll = () => this.classList.toggle('is-visible', window.scrollY > window.innerHeight);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }
    }

    customElements.define('custom-back-to-top', CustomBackToTop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-product"]) return;
  try {
    
  if (!customElements.get('custom-delivery-estimate')) {
    /*
     * Shows the estimated ship date: the next business day (or today before the
     * cutoff hour) plus the configured number of processing days, skipping weekends.
     * Uses the visitor's local time.
     */
    class CustomDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        const processingDays = Number(this.dataset.processingDays) || 0;
        const cutoffHour = Number(this.dataset.cutoffHour);
        const date = new Date();
        const isWeekend = (day) => day.getDay() === 0 || day.getDay() === 6;

        if (date.getHours() >= cutoffHour || isWeekend(date)) {
          do {
            date.setDate(date.getDate() + 1);
          } while (isWeekend(date));
        }

        for (let added = 0; added < processingDays; ) {
          date.setDate(date.getDate() + 1);
          if (!isWeekend(date)) added++;
        }

        const target = this.querySelector('[data-delivery-date]');
        if (!target) return;
        target.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
        }).format(date);
        target.closest('[hidden]')?.removeAttribute('hidden');
      }
    }

    customElements.define('custom-delivery-estimate', CustomDeliveryEstimate);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reviews-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-reviews-slider')) {
    /*
     * Endless horizontal slider with one dot per review.
     * A copy of all reviews is placed before and after the real ones. After every
     * scroll (arrows, swipe or dots) that ends inside a copy, the track jumps without
     * animation to the same review in the real set, so it keeps going in both
     * directions: past the last review comes the first, before the first the last.
     */
    class CustomReviewsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.custom-reviews__track');
        this.dotsContainer = this.querySelector('[data-dots]');
        this.dotLabel = this.dataset.dotLabel;
        this.realSlides = Array.from(this.track.children);
        this.count = this.realSlides.length;
        if (this.count < 2) return;

        this.addClones();
        this.buildDots();
        this.querySelectorAll('[data-arrow]').forEach((arrow) => {
          arrow.hidden = false;
          arrow.addEventListener('click', () => this.move(arrow.dataset.arrow === 'next' ? 1 : -1));
        });

        this.onScroll = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateActiveDot());
          if (!('onscrollend' in window)) {
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => this.onScrollEnd(), 150);
          }
        };
        this.onScrollEnd = () => {
          this.targetIndex = null;
          this.normalize();
          this.updateActiveDot();
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('scrollend', this.onScrollEnd);

        this.jumpTo(this.count);
        this.resizeObserver = new ResizeObserver(() => this.jumpTo(this.count + this.realIndex));
        this.resizeObserver.observe(this.track);

        // Theme editor: show the selected review block
        this.onBlockSelect = (event) => {
          const index = this.realSlides.indexOf(event.target);
          if (index > -1) this.jumpTo(this.count + index);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.track?.removeEventListener('scrollend', this.onScrollEnd);
        this.resizeObserver?.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      addClones() {
        const makeClone = (slide) => {
          const clone = slide.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.dataset.clone = '';
          [...clone.attributes].forEach(({ name }) => {
            if (name.startsWith('data-shopify')) clone.removeAttribute(name);
          });
          return clone;
        };
        const before = this.realSlides.map(makeClone);
        const after = this.realSlides.map(makeClone);
        this.track.prepend(...before);
        this.track.append(...after);
        this.slides = Array.from(this.track.children);
      }

      get slideStep() {
        return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
      }

      get currentIndex() {
        return Math.round(this.track.scrollLeft / this.slideStep);
      }

      get realIndex() {
        return (((this.currentIndex - this.count) % this.count) + this.count) % this.count;
      }

      jumpTo(index) {
        const behavior = this.track.style.scrollBehavior;
        this.track.style.scrollBehavior = 'auto';
        this.track.scrollLeft = index * this.slideStep;
        this.track.style.scrollBehavior = behavior;
        this.updateActiveDot();
      }

      scrollToIndex(index) {
        this.targetIndex = index;
        this.track.scrollTo({ left: index * this.slideStep, behavior: 'smooth' });
      }

      move(direction) {
        // Continue from the target of an arrow click that is still animating
        const from = this.targetIndex ?? this.currentIndex;
        this.scrollToIndex(from + direction);
      }

      // Inside a copy: jump to the same review in the real set
      normalize() {
        const index = this.currentIndex;
        if (index < this.count) this.jumpTo(index + this.count);
        else if (index >= this.count * 2) this.jumpTo(index - this.count);
      }

      buildDots() {
        this.dotsContainer.replaceChildren();
        this.dotsContainer.hidden = false;
        this.realSlides.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'custom-reviews__dot';
          dot.setAttribute('aria-label', `${this.dotLabel} ${index + 1}`);
          dot.addEventListener('click', () => this.scrollToIndex(this.count + index));
          this.dotsContainer.append(dot);
        });
      }

      updateActiveDot() {
        const active = this.targetIndex != null
          ? (((this.targetIndex - this.count) % this.count) + this.count) % this.count
          : this.realIndex;
        Array.from(this.dotsContainer.children).forEach((dot, index) => {
          dot.setAttribute('aria-current', String(index === active));
        });
      }
    }

    customElements.define('custom-reviews-slider', CustomReviewsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-sticky-atc')) {
    /*
     * Shows the bar once the main add to cart button has scrolled out of view.
     * Follows variant changes on the main product form, and updates its own price
     * and image when a variant is chosen in the bar.
     */
    class CustomStickyAtc extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select[name="id"]');
        this.button = this.querySelector('.custom-sticky-atc__button');
        this.buttonLabel = this.button?.querySelector('span');

        this.select?.addEventListener('change', () => this.renderVariant(this.select.value));

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (!data?.variant || !this.select) return;
            this.select.value = String(data.variant.id);
            this.renderVariant(data.variant.id);
          });
        }

        this.observeMainButton();
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        this.observer?.disconnect();
        document.body.classList.remove('custom-sticky-atc-visible');
      }

      observeMainButton() {
        const mainButton = document.querySelector('product-info[id^="MainProduct-"] .product-form__submit');
        if (!mainButton) return;

        this.observer = new IntersectionObserver(([entry]) => {
          this.setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
        this.observer.observe(mainButton);
      }

      setVisible(visible) {
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', String(!visible));
        this.querySelectorAll('select, button').forEach((element) => {
          element.tabIndex = visible ? 0 : -1;
        });
        document.body.classList.toggle('custom-sticky-atc-visible', visible);
        document.body.style.setProperty('--custom-sticky-atc-height', `${this.offsetHeight}px`);
      }

      renderVariant(variantId) {
        const template = this.querySelector(`template[data-variant-id="${variantId}"]`);
        if (!template) return;

        const price = this.querySelector('[data-sticky-price]');
        if (price) price.replaceChildren(template.content.cloneNode(true));

        const image = this.querySelector('[data-sticky-image]');
        if (image && template.dataset.image) {
          image.src = template.dataset.image;
          image.removeAttribute('srcset');
        }

        if (!this.button || !this.buttonLabel || !window.variantStrings) return;
        const available = template.dataset.available === 'true';
        this.button.toggleAttribute('disabled', !available);
        this.buttonLabel.textContent = available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
      }
    }

    customElements.define('custom-sticky-atc', CustomStickyAtc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
